import {
    UPDATE_PROPERTY,
    UPDATE_PROPERTY_FAILURE,

    UPDATE_PROPERTY_LOCALISATION,
    UPDATE_PROPERTY_LOCALISATION_FAILURE,
    UPDATE_PROPERTY_LOCALISATION_SUCCESS,
} from 'store/actions/types';

// Update property
export const updateProperty = (payload) => {
    return {
        type: UPDATE_PROPERTY,
        payload: payload,
    };
};

export const updatePropertyFailure = (error) => {
    return {
        type: UPDATE_PROPERTY_FAILURE,
        error: error,
    };
};

// Update property localisation
export const updatePropertyLocalisation = (payload, response) => {
    return {
        type: UPDATE_PROPERTY_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const updatePropertyLocalisationFailure = (error) => {
    return {
        type: UPDATE_PROPERTY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const updatePropertyLocalisationSuccess = (payload, response) => {
    return {
        type: UPDATE_PROPERTY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/properties/updateProperties.js